import { connect } from 'react-redux';
import { fetchPosts } from 'src/actions';

export default connect(
    state => ({
        selectedSource: state.selectedSource,
    }),
    dispatch => ({
        dispatch,
    }),
    ({ selectedSource }, { dispatch }) => ({
        refresh: () => {
            dispatch(fetchPosts(selectedSource));
        },
    })
);



// WEBPACK FOOTER //
// ./src/components/Header/Refresher/equip.js